import React, { useState, useEffect, useRef } from "react";
import crossIcon from "../assets/crossIcon.png";
// import { fetchContent } from "../services/api";
import { Translate } from "./LanguageChanger";
import Wrapper from "./shared/Wrapper";
import { userLoginSignup } from "../services/services";

let OTP = "";

const NumericKeyboard = ({ state, setState, navigate }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", "", "", "", "", ""]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [resendEnabled, setResendEnabled] = useState(false);
  const [timer, setTimer] = useState(60);
  const [isOtpScreen, setIsOtpScreen] = useState(false);
  const [isLoginScreen, setIsLoginScreen] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const inputRefs = useRef([]);
  const keyboardRefs = useRef([]);
  const resendRef = useRef();

  useEffect(() => {
    // Start the timer countdown
    const countdown = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    // Enable resend when the timer reaches 0
    if (timer === 0) {
      clearInterval(countdown);
      setResendEnabled(true);
    }

    return () => clearInterval(countdown);
  }, [timer]);
useEffect(() => {
  const MobileNumValue = localStorage.getItem("NewmobileNo");
 
  if (MobileNumValue) {
    const otpArray = MobileNumValue.split("").slice(0, 10); // Ensure max length is 10
    setOtp(otpArray);
  }
}, []);
  useEffect(() => {
    if (state.isNumericKeyboardSelected) {
      setSelectedIndex(0);
    } else {
      setSelectedIndex(-1);
    }
  }, [state.isNumericKeyboardSelected]);

  useEffect(() => {
    const handleGlobalKeyDown = (e) =>
      handleKeyboardNavigation(e, selectedIndex);
    if(state.isNumericKeyboardSelected) {
      window.addEventListener("keydown", handleGlobalKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleGlobalKeyDown);
    };
  }, [state.isNumericKeyboardSelected, selectedIndex]);

  useEffect(() => {
    if (
      /^\d*$/.test(formatOTPintoPhone(otp)) &&
      formatOTPintoPhone(otp).length <= 10
    ) {
      setState({ ...state, inputValue: formatOTPintoPhone(otp) });
    }
  }, [otp]);

   const handleMouseEnter = (index) => {
    // Mouse hover tabhi kaam karega jab keyboard pehle se active hai.
    // Isse "double focus" waali problem nahi hogi.
    // Aur jaise hi aap hover karenge, yeh keyboard ko activate bhi kar dega.
    if (!state.isNumericKeyboardSelected) {
      setState(prevState => ({
        ...prevState,
        isMobileSelected: false,
        isEmailSelected: false,
        isproceedSelected: false,
        isNumericKeyboardSelected: true, // Keyboard ko activate karo
      }));
    }
    setSelectedIndex(index); // Aur hover ki hui key ko select karo.
  };

  const handleResendOtp = () => {
    setOtp(["", "", "", "", "", ""]); // Clear OTP inputs
    setResendEnabled(false); // Disable the resend button
    setTimer(60); // Reset the timer
    // keyboardRefs.current[0]?.focus(); // Set focus back to the first key
    setSelectedIndex(0);
    keyboardRefs.current[selectedIndex]?.focus();
    setErrorMessage("");
    loadData();
  };

  const formatOTPintoPhone = (otp) => {
    let otpString = otp.join("");
    let otpArray = otpString.split("");
    let otpPhone = otpArray.join(" ");
    otpPhone = otpPhone.replace(/ /g, "");
    return otpPhone;
  };

  // useEffect(() => {
  //   if (
  //     /^\d*$/.test(formatOTPintoPhone(otp)) &&
  //     formatOTPintoPhone(otp).length <= 10
  //   ) {
  //     setState({ ...state, inputValue: formatOTPintoPhone(otp) });
  //   }
  // }, [otp]);

  useEffect(() => {
    if (
      /^\d*$/.test(formatOTPintoPhone(otp)) &&
      formatOTPintoPhone(otp).length <= 10
    ) {
      setState({ ...state, inputValue: formatOTPintoPhone(otp) });
    }
      if( formatOTPintoPhone(otp).length==10){
       setState(prevState => ({
        ...prevState,
        isMobileSelected: false,
        isEmailSelected: false,
        isproceedSelected: true,
        isNumericKeyboardSelected: false, 
        isDonePressed:true
        // Keyboard ko activate karo
      }));
    }
  }, [otp]);

  // useEffect(() => {
  //   if (
  //     /^\d*$/.test(formatOTPintoPhone(otp)) &&
  //     formatOTPintoPhone(otp).length <= 10
  //   ) {
  //     setState({ ...state, inputValue: formatOTPintoPhone(otp) });
  //   }
  // }, [otp]);

  // useEffect(() => {
  //   // Set focus to the first number in the keyboard by default
  //   keyboardRefs.current[0]?.focus();
  // }, []);

  // Set focus to the first number in the keyboard
  // useEffect(() => {
  //   if (!state.isNumericKeyboardSelected) {
  //     setSelectedIndex(-1);
  //   } else {
  //     setSelectedIndex(0);
  //   }
  // }, [state.isNumericKeyboardSelected]);

  const handleKeyboardNavigation = (e, index) => {
    if (!state.isNumericKeyboardSelected) return;
    e.preventDefault();
    // Handle numeric input (keys 0-9)
    const isNumberKey =
      (e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode >= 96 && e.keyCode <= 105);
    if (isNumberKey) {
      let number = e.keyCode >= 96 ? e.keyCode - 96 : e.keyCode - 48;

      if (number === 0 || (number > 0 && number <= 9)) {
        handleKeyPress(number - 1);
        setSelectedIndex(number - 1); // You may want to adjust this if multiple same numbers are pressed.
      }
      return; // Exit early to prevent further processing
    }

    // Handle arrow keys and other navigation
    switch (e.keyCode) {
      case 37: // Left Arrow
        if (index > 0) {
          if (state.isproceedSelected || state.isSkipLoginSelected) {
            setSelectedIndex(-1);
          } else {
            setSelectedIndex((prev) => (prev - 1 + 12) % 12);
          }
        }
        break;
      case 39: // Right Arrow
        if (state.isproceedSelected || state.isSkipLoginSelected) {
          setSelectedIndex(-1);
        } else {
          setSelectedIndex((prev) => (prev + 1) % 12);
        }

        break;
      case 38: // Up Arrow
        if (index === 0 || index === 1 || index === 2) {
          setState({
            ...state,
            isNumericKeyboardSelected: false,
            isMobileSelected: true,
            isEmailSelected: false,
          });
          setSelectedIndex(-1);
        }
        // console.log("asdfg", resendEnabled);
        if (resendEnabled && document.activeElement === resendRef.current) {
          // console.log("111111111....");
          setSelectedIndex(9); // Move focus back to Backspace
          resendRef.current?.blur();
        } else if (index >= 3) {
          // console.log("111111111..222222222..");

          setSelectedIndex((prev) => (prev - 3) % 12);
        }
        break;
      case 40: // Down Arrow
        if (
          selectedIndex === 11 ||
          selectedIndex === 10 ||
          selectedIndex === 9
        ) {
          setState({
            ...state,
            isNumericKeyboardSelected: false,

            // isNumericKeyboardOver: false,
            isproceedSelected: true,
            // isSkipLoginSelected: false,
            // selectedElementIndxNumeric: "1",
          });
          setSelectedIndex(-1);
        }

        if (resendEnabled && index >= 9) {
          keyboardRefs.current[selectedIndex]?.blur();
          setSelectedIndex(12);
          resendRef.current?.focus();
        } else if (index < 9) {
          // Regular down arrow navigation for other keys
          setSelectedIndex((prev) => (prev + 3) % 12);
        }
        break;
      case 13: // Enter
        // handleKeyPress(index);
        if (state.isNumericKeyboardSelected) {
          console.log(index);
          handleKeyPress(index);
        }
        break;
      case 461: // return key
        // navigate("LoginPage", {});
        // setIsLoginScreen(true);
        // setIsOtpScreen(false);
        // callBack("Back");
        break;
        setIsLoginScreen(true);
        setIsOtpScreen(false);
        break;
      case 10009:
        break;
      default:
        break;
    }
  };

  const handleKeyPress = (index) => {
    if (!state.isNumericKeyboardSelected) return;

    setOtp((prevOtp) => {
      const otpCopy = [...prevOtp];
      let inserted = false;

      // Handle input for numbers from 0 to 8
      if (index < 9) {
        for (let i = 0; i < otpCopy.length; i++) {
          if (otpCopy[i] === "") {
            otpCopy[i] = (index + 1).toString();
            inserted = true;
            break;
          }
        }
      }

      // Handle backspace (index 9)
      else if (index === 9) {
        for (let i = otpCopy.length - 1; i >= 0; i--) {
          if (otpCopy[i] !== "") {
            otpCopy[i] = "";
            inserted = true;
            break;
          }
        }
      }

      // Handle "0" input (index 10)
      else if (index === 10) {
        for (let i = 0; i < otpCopy.length; i++) {
          if (otpCopy[i] === "") {
            otpCopy[i] = "0";
            inserted = true;
            break;
          }
        }
      } else if (index === 11) {
        state.isNumericKeyboardSelected = false;
        state.isproceedSelected = true;
        state.isDonePressed = true;
      }

      if (inserted) {
        setErrorMessage(""); // Reset error message on valid input
      }
      return otpCopy;
    });
  };

  const keyEnter = (index) => {
    setSelectedIndex(index);
    setOtp((prevOtp) => {
      const otpCopy = [...prevOtp];
      let inserted = false;

      // Handle input for numbers from 0 to 8
      if (index < 9) {
        for (let i = 0; i < otpCopy.length; i++) {
          if (otpCopy[i] === "") {
            otpCopy[i] = (index + 1).toString();
            inserted = true;
            break;
          }
        }
      }

      // Handle backspace (index 9)
      else if (index === 9) {
        for (let i = otpCopy.length - 1; i >= 0; i--) {
          if (otpCopy[i] !== "") {
            otpCopy[i] = "";
            inserted = true;
            break;
          }
        }
      }

      // Handle "0" input (index 10)
      else if (index === 10) {
        for (let i = 0; i < otpCopy.length; i++) {
          if (otpCopy[i] === "") {
            otpCopy[i] = "0";
            inserted = true;
            break;
          }
        }
      } else if (index === 11) {
        state.isNumericKeyboardSelected = false;
        state.isproceedSelected = true;
        state.isDonePressed = true;
      }
      // Only update OTP state if something was inserted
      if (inserted) {
        setErrorMessage(""); // Reset error message on valid input
      }
      return otpCopy;
    });
  };

  const handleKeyDownOTP = (e) => {
    // read both series of numerical keys and if the key is not a number, prevent default

    console.log("reached otp handler");

    if (e.keyCode >= 48 && e.keyCode <= 57) {
      handleKeyPress(e.keyCode - 48);
    }

    if (e.keyCode >= 96 && e.keyCode <= 105) {
      handleKeyPress(e.keyCode - 96);
    }

    // handle backspace
    if (e.keyCode === 8) {
      handleKeyPress(9);
    }

    // handle done
    if (e.keyCode === 13) {
      handleKeyPress(11);
    }
  };

  const loadData = async () => {
    const myHeaders = {
      Version: localStorage.getItem("firmVersion"),
      devicetype: "11",
      Deviceid: localStorage.getItem("macAddress"),
      Devicetoken: localStorage.getItem("uuid"),
      Devicemodel: localStorage.getItem("productInfo"),

      "Content-Type": "application/json",
    };

    if (selectedIndex === 12) OTP = setOtp(["", "", "", "", "", ""]);
    else OTP = `${otp.join("")}`;

    const raw = {
      mobile: localStorage.getItem("mobileNo"),
      country_code: "+91",
      // otp: localStorage.getItem("getOTP"),
      otp: OTP,
    };

    // const requestOptions = {
    //   method: "POST",
    //   headers: myHeaders,
    //   body: JSON.stringify(raw),
    // };

    const body = JSON.stringify(raw);

    try {
      // const [response] = await Promise.all([
      //   fetchContent(
      //     "/V1/userLoginSignup",
      //     "POST",
      //     myHeaders,
      //     body,
      //     true
      //     // JSON.stringify(raw),
      //     // requestOptions
      //   ),
      // ]);

      const response = await userLoginSignup(body)

      console.log("response...", response);
      // const response = await fetchContent(
      //   "/V1/userLoginSignup",
      //   requestOptions
      // );
      // if (response.status === true) {
      //   localStorage.setItem("JWTToken", response.data.jwt);
      //   localStorage.setItem(
      //     "user_details",
      //     JSON.stringify(response.data.user_details)
      //   );
      //   navigate("WhoWatching", {});
      // } else {
      //   setTimeout(() => {
      //     setErrorMessage("");
      //   }, 10000);
      // }
      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }
      // const result = await response.json();

      if (response.message && response.status !== true) {
        setErrorMessage(response.message);

        // Hide the error message after 10 seconds
        setTimeout(() => {
          setErrorMessage("");
        }, 10000);
      } else if (response.messageCode === "108" && response.status === true) {
        if(response.data.jwt === null || response.data.jwt === undefined || response.data.jwt === ""){
          localStorage.setItem("JWTToken", response?.data?.tokens?.access);
        }else {
          localStorage.setItem("JWTToken", response.data.jwt);
        }
        // localStorage.setItem("JWTToken", response.data.jwt);
        localStorage.setItem(
          "user_details",
          JSON.stringify(response.data.user_details)
        );
        // console.log("response login devices....",response, response.data.user_details.is_device_limit_exceeded);
        if (response.data.user_details.is_device_limit_exceeded) {
          // console.log("Device limit exceed....", response);
          localStorage.setItem("user_device_info_id", JSON.stringify(response));
          navigate("ManageDevices", {});
        } else {
          // console.log("Device not exceed.....", response);
          navigate("WhoWatching", {});
        }
        // const userData = localStorage.getItem("user_details");
        // MenuScreen.ReseTfocus(4);
        // navigate("WhoWatching", {});
        // navigate("HomePage", {});
        // navigate("MyProfile", {});
      } else if (response.messageCode === "105" && response.status === true) {
        setErrorMessage(response.message);

        setTimeout(() => {
          setErrorMessage("");
        }, 10000);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    // Set focus to the currently selected key
    if (selectedIndex >= 0) {
      keyboardRefs.current[selectedIndex]?.focus();
    }
  }, [selectedIndex]);

  const isEmail = localStorage.getItem("isEmail") === "true";
  const isMobile = localStorage.getItem("isMobile") === "true";
  const mobileNo = localStorage.getItem("mobileNo");

  return (
    <div className="otp-container">
      <div className="otp-inputs">
        {otp.map((digit, idx) => (
          <input
            key={idx}
            value={digit}
            className="otp-box"
            id="inputField"
            readOnly
            ref={(el) => (inputRefs.current[idx] = el)}
          />
        ))}
      </div>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
      {/* Error message display */}
      <div className="keyboard">
        {[
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          "Backspace",
          0,
          <Translate langKey={"done"} />,
        ].map((key, index) => (
          <Wrapper
            key={index}
            className={`key ${selectedIndex === index ? "focused" : ""}`}
            onMouseEnter={() => handleMouseEnter(index)}
            onClick={(e) => keyEnter(index)}
            ref={(el) => {
              keyboardRefs.current[index] = el;
              console.log(`Assigned ref for index ${index}:`, el);
            }}
            tabIndex={-1}
            style={{
              width: "15vh",
              height: "6vh",
              fontSize: "20px",
              color: "white",
              backgroundColor: selectedIndex === index ? "#EC008C" : "#0E1653",
              border: "none",
              cursor: "pointer",
              outline: "none",
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {key === "Backspace" ? (
              <img src={crossIcon} alt="Backspace Icon" />
            ) : (
              key
            )}
          </Wrapper>
        ))}
      </div>

      {/* Inline CSS */}
      <style>
        {`
            .otp-container {
              color: rgba(255, 255, 255, 1);
            }
  
            h2 {
              margin-bottom: 10px;
              font-family: Anek Latin;
              font-weight: 700;
              font-size:38px
            }
  
            p {
              margin-bottom: 20px;
              font-family: Anek Latin;
              font-weight: 400;
              font-size:28px
            }
  
            .otp-inputs {
              display: flex;
              justify-content: center;
              margin-bottom: 20px;
            }
  
            .error-message {
              color: #EC008C;
              font-size: 20px;
              margin-top: 10px;
              margin:0;
              padding:0;
            }
  
            .otp-box {
              width: 2.8rem;
              height: 2.8rem;
              margin: 0 5px;
              font-size: 24px;
              text-align: center;
              border: 1px solid rgba(255, 255, 255, 1);
              background-color: #0E1653;
              color: white;
              outline: none;
              border-radius: 8px;
            }
  
            .keyboard {
              display: grid;
              grid-template-columns: repeat(3, 0fr);
              gap: 10px;
              justify-content: center;
              position:relative;
              top:0.2rem;
            }
  
            .resendotptimer {
              font-family:Anek Latin;
              font-weight: 400;
              font-size:16px;
              color:rgba(151, 151, 151, 1);
            }
  
            .key {
              width: 15vh;
              height: 6vh;
              font-size: 20px;
              color: white;
              background-color: #0E1653;
              border: none;
              cursor: pointer;
              outline: none;
              text-align: center;
              overflow: hidden;

            }
  
            .key.focused {
              background-color: #EC008C;
            }
  
            .resend-section {
              display: inline-flex;
            }
  
            .resend-section p{
              font-family:Anek Latin;
              font-weight:400;
              font-size:16px;
              color:rgba(151, 151, 151, 1);
            }
  
            .key:focus {
              outline: none;
            }
  
            .resend-otp {
              margin-top: 15px;
              font-size: 14px;
              color: gray;
              position:relative;
              top:2rem;
            }
  
            .resend-button {
              background: none;
              border: none;
              cursor: pointer;
              font-size: 14px;
              outline: none;
              margin-bottom:2px;
              font-family:Anek Latin;
              font-weight:600;
              font-size:16px;
              color:rgba(151, 151, 151, 1);
            }
          `}
      </style>
    </div>
  );
};

export default NumericKeyboard;
